import { useCallback } from 'react';
import { subscriptionClient } from '@bymason-private/controller-api';
import { useGetDataHook } from '@bymason/api-hooks-base';

/**
 * React hook that asynchronously gets current user's subscription.
 * @returns HookArray
 * @HookArray [0] getSubscription method
 * @HookArray [1] result
 * @HookArray [2] error
 * @HookArray [3] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 * @HookArray [6] clearData method
 */
export function useGetSubscription(clientToken: string) {
  const handleGetData = useCallback(
    ({}) => {
      return subscriptionClient.getSubscription(clientToken);
    },
    [clientToken]
  );

  return useGetDataHook(handleGetData);
}
